<template>
  <div id="loading" class="loading">
    <svg class="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 536 134.8"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M536,32.54H478.72L467.62,0h-21L435.56,32.54H380.62V0h-17.4V32.54h-81V14.6h55.4V0h-72.8V32.54h-30.2V0H217V32.54h-65.2V0h-17.4V32.54H78.22V14.8h41.2V0H19.62V14.8h41V32.54H0v72H60.62V134.8h17.6V104.54h56.2V134.8h17.4V104.54H217V134.8h17.6V104.54h30.2V134.8h75.8V120.2h-58.4V104.54h81V134.8h17.4V104.54H411.1L400.82,134.8h18l10-30.26h55.93L495,134.8h18.6l-10.32-30.26H536Zm-84.18,0c1.68-5.77,3.19-11.5,4.6-17.14h.4c1.42,5.54,2.84,11.18,4.62,17.14Z"/></g></g></svg>
<!--    <svg class="shadow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 536 134.8"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M536,32.54H478.72L467.62,0h-21L435.56,32.54H380.62V0h-17.4V32.54h-81V14.6h55.4V0h-72.8V32.54h-30.2V0H217V32.54h-65.2V0h-17.4V32.54H78.22V14.8h41.2V0H19.62V14.8h41V32.54H0v72H60.62V134.8h17.6V104.54h56.2V134.8h17.4V104.54H217V134.8h17.6V104.54h30.2V134.8h75.8V120.2h-58.4V104.54h81V134.8h17.4V104.54H411.1L400.82,134.8h18l10-30.26h55.93L495,134.8h18.6l-10.32-30.26H536Zm-84.18,0c1.68-5.77,3.19-11.5,4.6-17.14h.4c1.42,5.54,2.84,11.18,4.62,17.14Z"/></g></g></svg>-->
<!--    <div class="textlogo">Theia</div>-->
<!--    <img src="/assets/logoAnimation-looped.gif">-->
  </div>
</template>

<script>
export default {
  name: 'Loading',
};
</script>

<style scoped lang='scss'>
  @import './../assets/scss/theme';

  #loading {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    /*width: 100%;*/
    /*height: 100%;*/
    background: $dark100;
    color: $white;
    z-index: 3000;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1;
    transition: opacity 0.15s ease-in-out;
    pointer-events: initial;

    .textlogo {
      font-family: "Hind Madurai", sans-serif;
      text-transform: uppercase;
      font-size: 4rem;

      &:before {
        content: '';
        position: absolute;
        margin-left: -.1em;
        margin-top: .35em;
        width: 2.75em;
        margin-right: -.1em;
        height: .4em;
        background: $white;
        /*opacity: .5;*/
        animation: load .4s .7s;
      }
    }

    .logo {
      position: absolute;
      fill: $white;
      max-width: 8rem;
    }

    .shadow {
      position: absolute;
      fill: $white;
      max-width: 15rem;
      opacity: 0;
      animation:
        pulse1
        2s
        /*ease-out*/
        /*0s*/
        /*alternate*/
        infinite
        /*none*/
        running;
    }
  }

  .hide {
    opacity: 0 !important;
    pointer-events: none !important;

    .logo {
      transform: scale(.5);
      opacity: 0;
    }
  }

  @keyframes load {
    0% {
      width: 2.75em;
    }
    50% {
      width: 0;
    }
    100% {
      width: 2.75em;
    }
  }

  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1);
    }
  }

  @keyframes pulse1 {
    0% {
      transform: scale(1);
      opacity: 0;
    }
    100% {
      transform: scaleX(1.05) scaleY(1.1);
      opacity: 0.2;
    }
  }

  @keyframes pulse-animation {
    0% {
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2);
    }
    100% {
      box-shadow: 0 0 0 20px rgba(0, 0, 0, 0);
    }
  }

  img {
    max-width: 10rem;
  }
</style>
